export default __webpack_public_path__ + "static/media/P20007.76f9c5b6.png";